import React from 'react';
import styles from './Footer.module.scss';
import cn from 'classnames';

const Footer = ({ children, classname = '' }) => {
  return <div className={cn(styles.root, classname)}>{children}</div>;
};

export default Footer;
